import { useState, useEffect, RefObject, DependencyList } from "react";

const useIsOverflow = (
  ref: RefObject<HTMLDivElement>,
  dependencies: DependencyList,
): boolean => {
  const [isOverflow, setIsOverflow] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      if (ref.current) {
        setIsOverflow(ref.current.scrollHeight > ref.current.clientHeight);
      }
    };

    checkOverflow();
    window.addEventListener("resize", checkOverflow);

    return () => {
      window.removeEventListener("resize", checkOverflow);
    };
  }, [ref, ...dependencies]);

  return isOverflow;
};

export default useIsOverflow;
